export enum ProjectPropertyType {
  /** "Yes" to "infer class types" question */
  RDFS = 'RDFS',
  /**
   * "No" to "infer class types" question
   *
   * (also the default for new projects)
   */
  SCHEMA_ORG = 'SCHEMA_ORG',
  /** "Custom per property" */
  CUSTOM = 'CUSTOM',
}

export const enum ProjectResourceType {
  FILE_UPLOAD = 'FILE_UPLOAD',
  VIRTUAL_GRAPH = 'VIRTUAL_GRAPH',
}

export interface ProjectResourceItem {
  text: string;
  value: string;
  type: ProjectResourceType;
}

export const DEFAULT_PROJECT_PROPERTY_TYPE = ProjectPropertyType.SCHEMA_ORG;

export const PROJECT_MAPPING_RUN_SUGGESTIONS_PARAM = 'runSuggestions';
export const PROJECT_MAPPING_EXPAND_MAPPINGS_PARAM = 'expandMappings';
export const PROJECT_DIAGRAM_RESCALE_PARAM = 'rescale';
